import './assets/fonts.css'
import './index.css'
import './instrument'

import { StrictMode } from 'react'

import { config, WalletSDK } from '@optimex-xyz/trade-wallet-sdk'

import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { scan } from 'react-scan' // must be imported before React and React DOM

import router from './routers'
import { API_ENDPOINT, ENV, OPTIMEX_RPC_API_KEY, OPTIMEX_RPC_URL } from './utils'

import './i18n'

scan({
  enabled: import.meta.env.DEV,
})

// TODO: rorate the token instead of using the same token for all the time
const sdk = new WalletSDK()
sdk.setEnvironment(ENV)
config.set('privateRpcUrl', OPTIMEX_RPC_URL)
config.set('secretToken', OPTIMEX_RPC_API_KEY)
config.set('apiDomainUrl', API_ENDPOINT)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
)
